<h4>{{address.fname}} {{address.lname}}</h4>
<p class="line">{{address.line1}}</p>
@if (address.line2) {
<p class="line">{{address.line2}}</p>
}
<p class="addr">{{address.city}}, {{address.state}}, {{address.postal_code}}</p>
<p class="addr">{{address.country}}</p>
<mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
